import React from 'react';
import { useContent } from '../contexts/ContentContext';
import { usePageMetadata } from '../hooks/usePageMetadata';

const AboutPage: React.FC<{ embedded?: boolean }> = ({ embedded = false }) => {
    const Heading = embedded ? 'h3' : 'h2';
    const { content, language, t } = useContent();
    const aboutContent = content.ui[language].aboutPage;

    usePageMetadata({
        title: `${aboutContent.title} / ${content.siteName}`,
        enabled: !embedded,
        description: aboutContent.disclaimer[0]
    });

    return (
        <div className={embedded ? "lab-page" : "lab-page max-w-3xl mx-auto p-6"}>
            {!embedded && <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white border-b pb-4 border-gray-200 dark:border-gray-700">
                {aboutContent.title}
            </h1>}

            <div className="space-y-6 text-gray-700 dark:text-gray-300">
                <section>
                    <Heading className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">
                        {t('aboutHeadings.ownership')}
                    </Heading>
                    <ul className="list-disc list-inside space-y-2 ml-2">
                        <li>{aboutContent.sourceCode}</li>
                        <li>{aboutContent.imageOwnership}</li>
                    </ul>
                </section>

                <section>
                    <Heading className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">
                        {t('aboutHeadings.images')}
                    </Heading>
                    <p className="mb-2">{aboutContent.openAiInfo}</p>
                    <ul className="list-disc list-inside ml-2 space-y-1">
                        {aboutContent.openAiLinks.map((link, index) => (
                            <li key={index}>
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 dark:text-blue-400 hover:underline"
                                >
                                    {link.text}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <ul className="list-disc list-inside ml-2 mt-4 space-y-2">{aboutContent.imageNotes.map(note => <li key={note}>{note}</li>)}</ul>
                </section>

                <section className="border-t pt-4">
                    <Heading className="text-xl font-semibold mb-2 ">
                        {t('aboutHeadings.disclaimer')}
                    </Heading>
                    <div className="space-y-2">
                        {aboutContent.disclaimer.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AboutPage;
